<template>
  <v-autocomplete
    ref="autocomplete"
    v-model="value"
    :hide-selected="!isMultiple && items.length > 1"
    :search-input.sync="query"
    :hide-details="'auto'"
    :label="label"
    :persistent-hint="hint !== ''"
    :hint="hint"
    :disabled="loading || disabled"
    :loading="loading"
    :items="items"
    :item-text="itemText"
    :item-value="params.value || 'id'"
    :multiple="isMultiple"
    :no-filter="true"
    :clearable="!required"
    :no-data-text="messageEmpty"
    :rules="rules"
    :hide-no-data="!isEmpty"
    @click="isEmpty = false"
    @keydown="handleSearch($event)"
    @change="goToLink(items.find(item => valueAttributeItem(item) === value))"
  >
  <template v-slot:append >
    <v-icon>mdi-magnify</v-icon>
  </template>

  <template v-slot:no-data v-if="isFormGenercSearch">
    <v-list-item>
      <v-list-item-title>
        {{ $t("components.searchBox.formGeneric") }}
      </v-list-item-title>
    </v-list-item>
  </template>

  </v-autocomplete>
</template>

<script>

import Search from '../field-types/Search.vue';

const TOTAL_SEARCH = 1;

export default {
  name: 'CatalogSearch',
  extends: Search,
  data() {
    return {
      isFormGenercSearch: false,
      countSearchCatalog: 0,
    };
  },
  methods: {
    async refreshItems(queryValue = '') {
      const {
        target, filters, apicges,
      } = this.params;

      /// updates the evalued params for auto-update detection
      const evaluedFilters = this.evalParam(filters, queryValue);
      this.searchArguments.filters = JSON.parse(JSON.stringify(evaluedFilters));

      // for 'backend' target we will use the 'match' zparams value
      // to extend the filters with user input
      if (target === 'backend' && queryValue.trim() !== '') {
        const matchCondition = this.matchToFilters(queryValue);

        // if filters already includes an $or key
        // we will extend this $or with match conditions
        if (evaluedFilters.$or != null) {
          const { $or } = evaluedFilters;

          delete evaluedFilters.$or;
          evaluedFilters.$and = [
            { $or }, { $or: matchCondition },
          ];
        } else {
          evaluedFilters.$or = matchCondition;
        }
      }
      /// input text (query) saving
      this.searchArguments.query = queryValue;

      let evaluedApicges;
      if (apicges) {
        evaluedApicges = this.evalParam(apicges);
        this.searchArguments.apicges = evaluedApicges;
      }
      /// end

      const result = await this.search({ apicges: evaluedApicges, filters: evaluedFilters });

      // [FIX#1] close menu if opened before update items
      // if menu is active and we have fewer results than current items list
      // we force menu updating to ensure the position of the new menu items list
      const currMenuState = this.$refs.autocomplete.isMenuActive === true;
      if (currMenuState) {
        this.$refs.autocomplete.isMenuActive = false;
      }

      this.items = (result || {}).list[0].nr || [];

      // [FIX#1] reopen menu after items update
      if (currMenuState) {
        this.$refs.autocomplete.isMenuActive = true;
      }

      // we will include in first position the default value
      if (this.defaultItem != null) {
        // this.items.splice(0, 0, this.defaultItem);
        this.items.unshift(this.defaultItem);
      }

      // show form generic
      this.isEmpty = (this.items || []).length === 0;
      if (this.isEmpty) {
        this.countSearchCatalog += 1;
      } else {
        this.countSearchCatalog = 0;
      }
      if (this.countSearchCatalog >= TOTAL_SEARCH) {
        this.countSearchCatalog = 0;
        this.isFormGenercSearch = true;
      }
    },
    goToLink(data) {
      const { filters } = this.params;
      const { type } = this.evalParam(filters, '');
      this.$router.push(`/element/${type.toLowerCase()}/${data.id}`);
    },
    redirectToFormGeneralClick() {
      this.$root.$emit('openFormGeneric');
    },

  },
};
</script>
